import React, { useState } from 'react'
import classNames from 'classnames'
import { PREDEFINED_CROSS_CLIENT_QUERIES, PredefinedCrossClientQuery, FEATURED_CROSS_CLIENT_QUERIES } from '../../Predefined/crossClientPredefinedQueries'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientInitLoading } from '../../../../store/crossClient/crossClientLanding'
import './CrossClientLandingPredefinedQueries.scss'

export interface CrossClientLandingPredefinedQueriesProps {
  selectedCategory: string
  onSelect: (predefinedQuery: PredefinedCrossClientQuery) => void
  runDisabled?: boolean
}

export const CrossClientLandingPredefinedQueries: React.FC<CrossClientLandingPredefinedQueriesProps> = ({ selectedCategory, onSelect, runDisabled }) => {
  const initLoading = useAppSelector(selectCrossClientInitLoading)

  return (
    <div className='d-grid gap-2 justify-content-center align-items-start w-100 cross-client-predefined-grid zocks-mb-2'>
      {(selectedCategory === 'Featured' ? FEATURED_CROSS_CLIENT_QUERIES : PREDEFINED_CROSS_CLIENT_QUERIES[selectedCategory]).map((item) => (
        <div key={item.id} className='cross-client-predefined-grid-item'>
          <CrossClientLandingPredefinedQueryCard predefinedQuery={item} initLoading={initLoading} runDisabled={runDisabled} onClick={onSelect} />
        </div>
      ))}
    </div>
  )
}

interface CrossClientLandingPredefinedQueryCardProps {
  predefinedQuery: PredefinedCrossClientQuery
  initLoading: boolean
  runDisabled?: boolean
  onClick: (predefinedQuery: PredefinedCrossClientQuery) => void
}

const CrossClientLandingPredefinedQueryCard: React.FC<CrossClientLandingPredefinedQueryCardProps> = ({
  predefinedQuery,
  initLoading,
  runDisabled,
  onClick,
}) => {
  const isDisabled = runDisabled || initLoading
  const [hovered, setHovered] = useState<boolean>(false)

  return (
    <div
      className={classNames('d-flex flex-column align-items-start p-3 gap-3 zocks-border-0.5 border border-1 bg-white h-100 cross-client-transition', {
        'zocks-border-color-gray-200': !hovered || isDisabled,
        'zocks-border-color-primary cross-client-predefined-card-box-shadow': hovered && !isDisabled,
        'opacity-50 cross-client-predefined-card-disabled': isDisabled,
      })}
      role={isDisabled ? undefined : 'button'}
      onClick={() => {
        if (isDisabled) {
          return
        }
        onClick(predefinedQuery)
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className='paragraph-medium flex-grow-1'>{predefinedQuery.description}</div>
      <div className='d-flex gap-2 align-items-center'>
        <i className={`bi ${predefinedQuery.icon} fs-6 zocks-text-primary`} />
        <div className='paragraph-small text-uppercase zocks-text-primary medium'>{predefinedQuery.category}</div>
      </div>
    </div>
  )
}
